module.exports = __webpack_public_path__ + "img/crown2.d7794f38.svg";